import React from 'react';

const YARN = () => {
  return (
    <div>
      <h1>YARN Page</h1>
      <p>This is a placeholder page for YARN.</p>
    </div>
  );
};

export default YARN;
